module.exports = __webpack_public_path__ + "media/Video 3.ef094593.mp4";